(function ($, Drupal) {

  Drupal.behaviors.initRatingStars = {
    attach: function (context, settings) {

      $('.js_ratingStars', context).each(function () {

        let $el = $(this).find('.field__item').html(),
            $val = parseFloat($el);



      });

    }
  };

})(jQuery, Drupal);

